
import { getPageViewSize } from './util/screen';
import { commitid, gitOriginUrl } from './constants';

/**
 * Attach resource load exception function
 * Example: `resException(this.cacheUploader)`
 * @param {Function} function to upload log data
 * @param {Object} object to logger opts
 */
export function exception (ctx, opts) {
  ctx.resourceErrorHandler = (evt, errorData = {}) => {
    // 为资源容错插件提供交互接口
    // 1. 如果正在容错中，则不上报这个错误。判断条件为 evt.target.nextFallback 是否存在。
    // 2. 如果资源容错成功，则报一个容错成功的日志。判断条件为 evt.urlFallbackSuccess 是否存在。
    // 3. 如果没有接入资源容错或容错失败，则走原逻辑上报错误日志。
    if (evt.target.nextFallback) return;
    const {
      from,
      successsource,
      failsource,
      loglevel,
      errorlist
    } = evt.urlFallbackSuccess || {}

    // 目前只统计link、script和img三种资源错误
    if (evt.target.tagName) {
      // 记录页面错误元素
      var target = evt.target ? evt.target : evt.srcElement;
      errorData.outerHTML = (target && target.outerHTML).slice(0, 200);
      // 记录错误时间戳
      errorData.timestamp = evt.timeStamp || '';
      // 记录XPath资源错误定位符
      errorData.XPath = (function (target) {
        var arr = [];
        for (
          ;
          target && target.nodeType === window.Node.ELEMENT_NODE;
          target = target.parentNode
        ) {
          var pre;
          var index = 0;
          var bool = false;
          for (pre = target.previousSibling; pre; pre = pre.previousSibling) {
            pre.nodeType !== window.Node.DOCUMENT_TYPE_NODE &&
              pre.nodeName === target.nodeName &&
              ++index;
          }
          for (pre = target.nextSibling; pre && !bool; pre = pre.nextSibling) {
            pre.nodeName === target.nodeName && (bool = true);
          }
          var left =
            (target.prefix ? target.prefix + ':' : '') + target.localName;
          var right = index || bool ? '[' + (index + 1) + ']' : '';
          arr.splice(0, 0, left + right);
        }
        return arr.length ? '/' + arr.join('/') : null;
      })(target);
      // 记录Selector资源错误定位符
      errorData.selector = (function (target) {
        var arr = [];
        for (; target.parentNode;) {
          if (target.id) {
            arr.unshift('#' + target.id);
            break;
          }
          if (target === target.ownerDocument.documentElement) {
            arr.unshift(target.tagName);
          } else {
            var i = 1;
            for (
              var el = target;
              el.previousElementSibling;
              el = el.previousElementSibling, i++
            );
            arr.unshift(target.tagName + ':nth-child(' + i + ')');
          }
          target = target.parentNode;
        }
        return arr.join(' > ');
      })(target);
      errorData.type = 'Resource';
      errorData.effectiveType = navigator?.connection?.effectiveType || '';
      errorData.pageviewsize = getPageViewSize();
      errorData.commitid = commitid
      errorData.gitOriginUrl = gitOriginUrl
      errorData.url = (evt.target && evt.target.src) || evt.target.href || '';
      errorData.performanceResourceTiming = performance?.getEntriesByName?.(errorData.url).filter(e => e.initiatorType === "script")[0] || null
      errorData.baseURI = (evt.target && evt.target.baseURI) || '';
      errorData.tagName = (evt.target && evt.target.tagName) || '';
      if (from) errorData.from = from
      if (successsource) errorData.successsource = successsource
      if (failsource) errorData.failsource = failsource
      if (loglevel) errorData.loglevel = loglevel
      if (errorlist) errorData.errorlist = errorlist
      if (
        errorData.url &&
        (typeof errorData.url === 'string' ||
          errorData.url instanceof String) &&
        errorData.url.indexOf(opts.baseURL) !== 0
      ) {
        ctx.cacheUploader(errorData, 'c', 'res');
      }
    }
  }

  if (window.__sourceError && window.__sourceError.constructor === Array) {
    for (var i = 0; i < window.__sourceError.length; i++) {
      ctx.resourceErrorHandler(window.__sourceError[i]);
    }
  }

  if (window.addEventListener) {
    window.addEventListener('error', event => ctx.resourceErrorHandler(event), true);
    window.addEventListener('url-fallback-success', event => ctx.resourceErrorHandler(event), true);
  }
}
